<template>
  <div>
    <headers :tabIndex="1"></headers>
    <div class="case-box">
      <div class="case-banner">
          <span class="homme-sp1">基于数字化的工程检测［专精特新］之道</span>
          <span class="homme-sp2">把数字化带入预应力工程中的每个构件、每个项目、每个组织，构建“数字建造”时代的工程物联网世界</span>
        <img src="@/assets/imgs/wap/6.png"/>
      </div>

      <div class="case-content">
          <div class="t1">典型案例</div>
              <div class="case-content-box">
                <div class="case-li flex-center" v-for="item in projectList" :class="{'select':item.cover}"
                     @click="toPape(item)">
                  <img v-if="item.cover" :src="item.cover"/>
                  <div style="text-align: center;position: relative;z-index: 2">
                    <p class="year" :style="{'color':item.cover?'#ffffff':''}">{{item.year}}</p>
                    <p class="name" :style="{'color':item.cover?'#ffffff':''}">{{item.name}}</p>
                    <div class="line" :style="{'background':item.cover?'#ffffff':''}"></div>
                    <p class="detail select" :style="{'color':item.cover?'#ffffff':''}">{{item.orgName}}</p>
                    <div class="more select" :style="{'color':item.cover?'#ffffff':''}">查看详情</div>
                  </div>
                </div>
              </div>
      </div>


      <div class="type-title">全数量检测的引领者</div>
      <div class="type-content-left">
        <ul>
          <li v-for="item in typeList" :class="{'select':typeSelect==item.code}"
              @click="bnt_selectType(item.code)">{{item.name}}
          </li>
        </ul>
      </div>
      <div class="type-box" :style="{'background-image':'url('+proObjList.cover+')'}">
          <div class="type-content">

            <div class="type-content-right">
              <div class="pName">{{proObjList.name}}</div>
              <div class="pDetail">{{proObjList.digest}}
              </div>
              <div class="pBtn flex-center"  @click="toPape(proObjList)">查看案例</div>
            </div>
          </div>
        </div>
    </div>
    <footers></footers>
  </div>
</template>


<script>
  import headers from "@/components/wap/header1"
  import footers from "@/components/wap/footer"
  import axios from "axios";
  export default {
    name: 'wapTechnological',
    components:{headers,footers},
    data() {
      return{
        projectList: [],
        typeSelect: "",
        typeList: [],
        selectIndex1: 1,
        pageIndex1: 0,
        proObjList:{
          name:"",
          orgName:"",
          cover:""
        },
      }
    },
    mounted() {
      this.getProjectcList()
      this.getTypeList();
    },
    beforeDestroy() {
    },
    methods:{
      toPape(data) {
        this.$router.push({
          path: '/caseDetail',
          query: {
            id: data.id
          }
        })
      },
      bnt_selectType(val) {
        this.typeSelect = val
        this.getAProjectcList(val)
      },
      //获取案例项目
      getProjectcList() {
        axios.get(this.pageUrl + `/project-case/page?pageNo=${this.selectIndex1}&pageSize=200`).then(res => {
          this.pageIndex1 = res.data.data.pages;
          this.projectList = res.data.data.list;

        })
      },
      getAProjectcList(code) {
        axios.get(this.pageUrl + `/project-case/page?pageNo=${this.selectIndex1}&pageSize=200&typeCode=${code}`).then(res => {
          this.proObjList = res.data.data.list.length>0?res.data.data.list[0]:{
            name:"",
            orgName:""
          };
        })
      },
      //获取项目类型
      getTypeList(){
        axios.get(this.pageUrl + `/project-case-type/page?pageNo=1&pageSize=200`).then(res => {
          this.typeList = res.data.data.list;
          this.typeSelect = res.data.data.list[0].code
          if(this.$route.query.index){
            this.typeSelect=this.$route.query.index
            this.getAProjectcList(this.$route.query.index)
          }else {
            if(this.typeList[0]){
              this.getAProjectcList(this.typeList[0].code)
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
  .case-banner{
    width: 100%;
    padding-top: 1rem;
    height: 13.34rem;
    position: relative;
  }
  .case-banner img{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    object-fit: cover;
    left: 0;
    z-index: 0;
  }
 .case-banner .homme-sp1{
   font-size: 0.48rem;
   font-family: PingFang SC-Heavy, PingFang SC;
   font-weight: 800;
   color: #19203B;
   position: relative;
   z-index: 1;
   padding:0 0.68rem;
   animation-name: fadeInUp;
   animation-duration:1s;
   animation-timing-function:ease;
   display: block;
   margin-top: 1.34rem;
 }
  .case-banner .homme-sp2{
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #19203B;
    position: relative;
    z-index: 1;
    animation-name: fadeInUp;
    animation-duration:1s;
    animation-delay: 1s;
    animation-timing-function:ease;
    animation-fill-mode:forwards;
    opacity: 0;
    padding:0 0.68rem;
    display: block;
    width: 5.4rem;
    line-height: 2;
    margin: 0.8rem 0 0;
  }
  .case-content{
    padding-top: .4rem;
  }
  .case-content .t1{
    font-size: 0.36rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
    display: block;
    text-align: center;
  }
  .case-content .case-content-box{
    display: -webkit-inline-box;
    width: 100%;
    overflow: auto;
    margin-top: 0.4rem;
  }
  .case-content .case-content-box .case-li{
    width: 6.04rem;
    height: 6.8rem;
    position: relative;
    border-radius:0.16rem;
    overflow: hidden;
    margin-right: 0.2rem;
  }
  .case-content .case-content-box .case-li img{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
  }
  .case-content .case-content-box .case-li .year{
    font-size: 0.48rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
  }

  .case-content .case-content-box .case-li .name{
    font-size: 0.36rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    margin-top: 0.14rem;
  }
  .case-content .case-content-box .case-li .line{
    width: 1.4rem;
    height: 0.04rem;
    margin: .1rem auto;
    background: #FFFFFF;
  }
  .case-content .case-content-box .case-li .detail{
    font-size: 0.36rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
  }
  .case-content .case-content-box .case-li .more{
    background: linear-gradient(33deg, #34E4AA 0%, #2C68FF 100%);
    border-radius: 1.76rem;
    font-size: 0.2rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    width: 1.36rem;
    height: .42rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1rem auto 0;
    color: #FFFFFF;
  }
  .type-title{
    font-size: 0.36rem;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: bold;
    color: #19203B;
    text-align: center;
    margin-top: 0.2rem;
    margin-bottom: 0.4rem;
  }

   .type-content-left ul{
    font-size: 0.32rem;
    display: -webkit-inline-box;
    list-style: none;
     padding: 0 0.2rem;
    margin: 0;
     overflow: auto;
     box-sizing: border-box;
    width: 100%;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #5C5D5F;
  }
  .type-content-left ul li{
    margin-right: .4rem;
  }
  .type-content-left ul li.select{
    color: rgba(0, 113, 239, 1);
    position: relative;
    padding-bottom: 0.3rem;
  }
  .type-content-left ul li.select:after{
    content: " ";
    width: 100%;
    height: 0.04rem;
    left: 0;
    position: absolute;
    z-index: 99;
    background: rgba(0, 113, 239, 1);
    top: 0.56rem;
  }
  .type-box{
    background-size: cover;
    margin-bottom: 0.8rem;
  }
  .type-content-right{
    padding: .5rem 0.36rem;
    min-height: 10rem;
    position: relative;
  }
  .type-content-right .pName{
    font-size: 0.32rem;
    text-align: center;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
  }
  .type-content-right .pDetail{
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
    margin-top: 0.4rem;
    line-height: 2;
  }
  .type-content-right .pBtn{
    width: 1.36rem;
    height: 0.42rem;
    background: linear-gradient(33deg, #34E4AA 0%, #2C68FF 100%);
    border-radius: 1.76rem;
    font-size: 0.2rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    bottom: 0.8rem;
  }
</style>



// WEBPACK FOOTER //
// src/view/case/wapIndex.vue